var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBronzeStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60988_10561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4.63862L7.64219 4.35203L6 0.226562L4.3578 4.35205L0 4.63865L3.34355 7.47294L2.24662 11.7779L6 9.40569L9.75338 11.7779L8.6565 7.47313L12 4.63862ZM6 8.5739L3.36412 10.2398L4.13351 7.22036L1.77724 5.22618L4.84688 5.02455L6 2.12772L7.15313 5.02457L10.2263 5.22618L7.86645 7.22017L8.63587 10.2398L6 8.5739Z",
    fill: "url(#paint0_linear_60988_10561)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60988_10561",
    x1: 1.9,
    y1: 1.863,
    x2: 9.81977,
    y2: 12.0729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6947E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F6959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#F8DAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#AC836E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#B6947E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8DCCB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60988_10561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeStar);
export default __webpack_public_path__ + "static/media/bronze_star.3a63ee467279b69c5f61468985b04379.svg";
export { ForwardRef as ReactComponent };